import React, { useState } from "react";
import axios from "axios";
import { env } from "../../../config";
import { keycloak } from "../../../auth/keycloakService";

interface FormValue {
  length: number;
  format: "alphanumeric" | "numeric" | "special" | "alphabets";
  quantity: number;
  letterCase: "uppercase" | "lowercase" | "mixed";
  prefix: string;
}

const GenerateCoupon = () => {
  const [formValue, setFormValue] = useState<FormValue>({
    length: 8,
    format: "alphanumeric",
    quantity: 1,
    letterCase: "mixed",
    prefix: "",
  });

  const [error, setError] = useState<string | null>(null);
  const [apiResponse, setApiResponse] = useState<any>(null);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { id, value } = e.target;
    setFormValue((prev) => ({
      ...prev,
      [id]: id === "length" || id === "quantity" ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsFetching(true);
    // Basic validation
    if (formValue.length < 1 || formValue.quantity < 1) {
      setError("Length and Quantity must be greater than 0");
      setIsFetching(false);
      return;
    }
    setError(null);

    try {
      const response = await axios.post(
        `${env.REACT_COUPON_URL}/default/generate_coupon_code`,
        formValue
      );
      console.log("API Response:", response.data);
      if (response.data?.coupons) {
        setApiResponse(env.S3_BUCKET_URL + "/" + response.data?.coupons);
      }
    } catch (error: any) {
      console.error("Error calling API:", error);
      setError(
        error?.response?.data?.error ||
          "Failed to generate coupons. Please try again."
      );
    } finally {
      setIsFetching(false);
    }
  };
  console.log("ID Token:", keycloak.idToken);
  console.log("Access Token:", keycloak.token);
  console.log("User Info:", keycloak.tokenParsed);
  return (
    <div className="">
      <form onSubmit={handleSubmit} className="">
        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

        {/* Code Length */}
        <div className="flex justify-between gap-2">
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="length"
            >
              Code Length
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="length"
              type="number"
              min="1"
              value={formValue.length}
              onChange={handleChange}
              placeholder="Code Length"
            />
          </div>

          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="prefix"
            >
              Prefix
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="prefix"
              type="text"
              min="1"
              value={formValue.prefix}
              onChange={handleChange}
              placeholder="Prefix"
            />
          </div>
        </div>
        {/* Code Format */}
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="format"
          >
            Code Format
          </label>
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            id="format"
            value={formValue.format}
            onChange={handleChange}
          >
            <option value="alphanumeric">Alphanumeric</option>
            <option value="numeric">Numeric</option>
            <option value="special">Special</option>
            <option value="alphabets">Alphabets</option>
          </select>
        </div>

        {/* Quantity */}
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="quantity"
          >
            Unique Code Quantity
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="quantity"
            type="number"
            min="1"
            value={formValue.quantity}
            onChange={handleChange}
            placeholder="Code Quantity"
          />
        </div>

        {/* Code Case */}
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="letterCase"
          >
            Code Case
          </label>
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            id="letterCase"
            value={formValue.letterCase}
            onChange={handleChange}
          >
            <option value="uppercase">Uppercase</option>
            <option value="lowercase">Lowercase</option>
            <option value="mixed">Mixed</option>
          </select>
        </div>
        {isFetching && <p className="mb-4 text-center">Please Wait...</p>}
        {/* Submit Button */}
        <div className="flex items-center justify-between">
          <button
            className="px-4 py-2 bg-gray-700 text-white rounded"
            type="submit"
            disabled={isFetching}
          >
            Generate Coupons
          </button>
          <a
            className={`px-4 py-2 bg-gray-700 text-white rounded ${
              apiResponse ? "opacity-100" : "opacity-50"
            }`}
            download={"coupons"}
            href={apiResponse}
          >
            Download Coupons
          </a>
        </div>
      </form>
    </div>
  );
};

export default GenerateCoupon;
